import { AlertRuleContainer } from "./AlertRuleContainer";

export default AlertRuleContainer;
